import React from 'react'
import SvgIcon from './SvgIcon'

export default SvgIcon(
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.47 31.47"><title>SiteIcons</title><path d="M31.47,15.73A15.73,15.73,0,1,0,15.73,31.47,15.75,15.75,0,0,0,31.47,15.73ZM15.73,29.81A14.08,14.08,0,1,1,29.81,15.73,14.09,14.09,0,0,1,15.73,29.81Z"/><path d="M21,11.1l-6.84,7.63L11.8,16.36a.83.83,0,1,0-1.17,1.17l3,3a.83.83,0,0,0,.59.24h0a.83.83,0,0,0,.59-.27l7.43-8.28A.83.83,0,1,0,21,11.1Z"/></svg>
)